import { render, staticRenderFns } from "./BrandInputs.vue?vue&type=template&id=28f1d57f&"
import script from "./BrandInputs.vue?vue&type=script&lang=ts&"
export * from "./BrandInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports